import { Entidad } from "../../../../data/Entidad";
import { MGrado } from "../../../../data/model/MGrado";
import { IGridExtraColumns } from "../entidad/GridExtraColumns";
import { MGrupoGrid } from "./MGrupoGrid";

export class MGradoGrid extends MGrado implements IGridExtraColumns {
    TagNivel: string | number;
    TagGrado: string | number;
    TagGrupo: string | number;
    TagAlumno: string | number;
    Alumnos: Map<number, Entidad.IAlumno>;

    Grupos: MGrupoGrid[];

    constructor(gradoModel: MGrado) {
        super(gradoModel);

        this.Alumnos = new Map(this.getAlumnosEnGrado().map(a => [a.IdChild, a]));
        this.TagAlumno = this.Alumnos.size;
        this.TagGrado = this.Nombre;
        this.Grupos = Array.from(this.getGruposEnGrado().values())
            .map(grupo => new MGrupoGrid(grupo));

        this.TagGrupo = this.Grupos.length;
    }

    public getAlumnosActivos(): number {
        return Array.from(this.Alumnos.values())
            .filter(d => (d.IdChildMovimiento == Entidad.CNinioMovimiento.Activo))
            .length;
    }
}